<template>
  <div class="rsvp-form" no-inner-pad :bg="colors.tan">
        <button-block
            :label="'RSVP For Pittsburgh'"
            :fg="colors.paleYellow"
            :bg="colors.coral"
            v-on:click="goToRSVPForm"
            />
  </div>
</template>

<script>
import ButtonBlock from '@/components/ButtonBlock.vue'
import { colors } from '@/colors.js'
let rsvpLink = 'https://docs.google.com/forms/d/e/1FAIpQLSfC18iMMvddfDEkVpmzCIZjkjoGXsGLXseAQL9PYKtQe6ur3w/viewform'

export default {
  name: 'rsvp-form',
  components: {
      ButtonBlock,
  },
  props: {
    // style
    bg: String,
    fg: String,
  },
  data () {
    return {
        colors,
    }
  },
  methods: {
      goToRSVPForm () {
          window.location.href = rsvpLink;
      }
  }
}
</script>

<style lang="scss">
@import '@/colors.scss';

$header-field-label-top-pad: 8px; // a
$header-field-label-height: 24px; // b
$header-field-label-bot-pad: 4px; // d
$header-field-height: $header-field-label-top-pad + $header-field-label-height; // c

$header-row-height: 32px;

.rsvp-form {
    // padding: 100px;
    color: $color-tan-darkest;
    transition: height 1s;
}

.rsvp-form__inner {
    display: flex;
    flex-direction: column;
}
.rsvp-form__header {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.rsvp-form__title {
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
    flex-grow: 1;
    height: 71px;
    line-height: 71px;
    box-sizing: border-box;
}
.rsvp-form__guest-details {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid $color-tan-dark;
    flex-grow: 1;
    height: 71px;
    box-sizing: border-box;
}
.rsvp-form__guest-details {
    height: 71px;
    box-sizing: border-box;
    min-width: 215px;
}
.rsvp-form__guest-details > label {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    flex-shrink: 0;
    align-items: flex-end;
    padding: 4px 8px;
    height: $header-row-height;
    box-sizing: border-box;
    color: $color-tan-dark;
}
.rsvp-form__guest-details > label > span {
    width: 70%;
    padding-right: 5px;
}
.rsvp-form__guest-details > label > input {
    width: 30%;
}
.rsvp-form__guests {
    flex-grow: 4;
}
.rsvp-form__guest-name {
    display: flex;
    flex-direction: column;
    color: $color-tan-dark;
}
/*
$header-field-label-top-pad
$header-field-label-height
$header-field-label-bot-pad
$header-field-height
*/
.rsvp-form__guest-name__label {
    // margin-top: $header-field-label-top-pad;
    // height: $header-field-label-height;
    // margin-bottom: $header-field-label-bot-pad;
    // height: $header-row-height;
    padding: 4px 8px;
    padding-top: $header-row-height - 19; // 19 was height measured in browser
}
.rnd-input {
    font-family: 'regina_blacksolid', serif;
    font-size: 16px;
    background: transparent;
    border: none;
    border-bottom: 1px solid $color-tan-dark;

    &:focus {
        outline: none;
        background-color: rgba($color-tan-dark, 0.2);
    }
}
.rsvp-form__guest-name__input {
    display: block;
    // height: $header-field-height;
    padding-left: 8px;
    height: $header-row-height;
    &::placeholder {
        color: rgba($color-tan-darkest, 0.2);
    }
}
.rsvp-form__locations {
    display: flex;
    flex-direction: row;
}
.rsvp-form__location {
    flex-grow: 1;
    position: relative;
    overflow: hidden;
    min-height: 300px;
    border-bottom: 1px solid $color-tan-dark;
}
.rsvp-form__pgh {
    border-right: 1px solid $color-tan-dark;
}
.rsvp-form__loc-image {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
}
.rsvp-form__loc-details {
    position: relative;
    z-index: 1;
    user-select: none;
} 
.rsvp-form__confirm {
    padding: 25px;
    background-color: $color-tan-dark;
}

// START CHECKBOX

.rsvp-form__checkbox {
    display: flex;
}
.rsvp-form__checkbox-container {
    padding-top: 8px;
}
.rsvp-form__checkbox-container input[type="checkbox"] {
    opacity: 0;
    width: 1;
    height: 1;
    position: absolute;
}
.rsvp-form__checkbox-label {
    display: block;
    user-select: none;

    position: relative;

    box-sizing: border-box;

    padding: 0 10px;
    // padding-left: 42px;
    
    background-color: $color-tan-darkest;
    color: $color-tan;

    height: 32px;
    line-height: 32px;
}
.rsvp-form__checkbox-box {
    display: block;
    box-sizing: border-box;

    // position: absolute;
    
    height: 32px;
    width: 32px;

    top: 0;
    left: 0;
    
    border: 2px solid;
    background-color: $color-tan;
}
.rsvp-form__checkbox-check {
    display: block;
    height: 28px;
    width: 28px;
    margin: 0px;
    // background-color: green;
    font-size: 28px;
    text-align: center;
    line-height: 28px;

    color: $color-tan-darkest;
    background-color: $color-gold;

    display: none;

}
input[type="checkbox"]:checked + .rsvp-form__checkbox-box .rsvp-form__checkbox-check {
    display: block;
}
// END CHECKBOX
.rsvp-form__loc-details {
    padding: 20px;
}
.rsvp-form__pgh .rsvp-form__loc-details {
    text-align: right;
    .rsvp-form__checkbox {
        flex-direction: row-reverse;
    }
}
//
.error {
    background-color: $color-coral;
    color: $color-gold;
    outline: 4px solid $color-gold;
    // box-shadow: 2px 2px 0 #000;
    box-shadow: inset 2px 2px 0 rgba(0,0,0,0.3);

    input::placeholder {
        color: rgba($color-tan-darkest, 0.5);
    }
}
.rsvp-form__inner {
    position: relative;
}
.rsvp-form__success {
    padding: 20px;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}
.rsvp-form__error {
    padding: 15px;
    text-align: center;
    color: $color-gold;
    background-color: $color-coral;
    margin: 13px;
    margin-right: 21px;
    a {
        color: #ffffff;
    }
    
}

// mobile / responsive:
.rsvp-form__title--long {
    display: none;
}
@media (max-width: 700px) {
    .rsvp-form__title--long {
        display: block;
    }
    .rsvp-form__title--short {
        display: none;
    }

    .rsvp-form__header, .rsvp-form__locations {
        flex-direction: column;
        align-items: stretch;
    }

    .rsvp-form__pgh .rsvp-form__loc-details {
        text-align: left;
    }
    .rsvp-form__pgh .rsvp-form__loc-details .rsvp-form__checkbox {
        flex-direction: row;
    }

    .rsvp-form__location {
        min-height: 180px;
    }

    .rsvp-form__loc-image {
        opacity: 0.6;
    }

    .rsvp-form__confirm {
        padding: 10px 0px;
    }
}
</style>
